/*

File handles all api calls for tenants


*/
import { browserHistory } from 'react-router'
import { server } from '../engine/server'
import { modal } from '../utilities/modal'
import { tenant } from './Tenant';

var Lease = Class.create({
  	initialize: function() {
        // #  Prepare our server object for data use
  		this.server = server;
		this.leaseID = 0;
		this.didMoveIn = false;
	},

	getLease: function(callback) {
		// Call server for our data
		// #  Localize this instance for use on success
		var self = this;
		// prepare our data to be sent
		var url = "leases/" + self.leaseID;
		// #  Send to server object for processing
		var data = this.server.getData(url,null,true);
		// #  Listen to our data
		data
		.done(function(response){
			// #  Validate response
			if(response.data.error_user_authentication == 1)
			{
			}
			else if(response.data.error || (response.status == 1 || response.status == 2))
			{
				// #  Display error
                modal.showInfo("Oops! " + response.data.error, "danger", "top", "center");
			}
			if (callback) {
				callback(response)
			}
		})
		.fail(function(e){
			modal.showInfo("Oops! Something went wrong!", "danger", "top", "center");
		});
	},

	/**
	*
	* Deletes a tenant
	*
	*/
	deleteLease: function(e){
		// #  Localize this instance for use on success
      var self = this;
      // #  Send out success message
      modal.showDangerModalWithOK("Are you sure?","You are about to delete this lease.  All data associated will be deleted and you will not be able to recover.","Yes, Delete");
      // #  Bind okay button
      jQuery(".move-on").on('click',function() {
		// prepare our data to be sent
		var url = "leases/" + self.leaseID;
		// #  Send to server object for processing
		var data = self.server.getData(url,null,true, "DELETE");
	    // #  Listen to our data
        data
        .done(function(response){
          // #  Validate response
          if(response.status == 1 || response.status == 2)
          {
            // #  Display error
            modal.showInfo("Oops! Something went wrong!", "danger", "top", "center");
          }
          else if(response.data.error != null)
          {
            modal.showInfo("Error occurred: " + response.data.error + ". Please try again", "danger", "top", "center");
          }
          else
          {
            // # .Hard reset backdrop
			modal.resetBackDrop();
            // #  Send out success message
            modal.showSuccess("Lease Deleted!","This lease has been dropped.  All associated information with this lease has been removed and any associated tenant(s) have been notified.");
            // #  Bind okay button
            jQuery(".move-on").on('click',function() {
				browserHistory.goBack();
            });
          }
        })
        .fail(function(e){
            modal.showInfo("Oops! Something went wrong!", "danger", "top", "center");
        });
      });
	},

	/**
	*
	* Saves lease data
	*
	*/
	saveLease: function(context) {
		var self 		   = this;
		const leaseData    = context.state.leaseData;
		var url 		   = "leases/" + self.leaseID;
		var params 		   = context.state.lease;
		var tenantIdString = '';
		const tenantArray  = context.state.tenantArray;
		if(tenantArray !== undefined && tenantArray.length != 0) {
			for (var i = 0; i < tenantArray.length; i++) {
				if(i + 1 < tenantArray.length) {
					tenantIdString += tenantArray[i].id + ',';
				} else {
					tenantIdString += tenantArray[i].id;
				}
			}
		}

		params['security_deposit'] 			= leaseData.deposit_amount;
		params['pet_deposit'] 				= leaseData.pet_deposit_amount;
		params['rent_increase_in_months']  	= leaseData.increase_rent_length;
		params['rent_increase_amount']  	= leaseData.increase_rent_amount;
		params['sales_max_amount'] 			= leaseData.sales_max;
		params['sales_min_amount'] 			= leaseData.sales_min;
		params['sales_percentage'] 			= leaseData.sales_percentage;
		params['prorate_rent'] 				= leaseData.prorate_amount;
		params['tenant_id']               	= tenantIdString;
		params['title'] 					= context.state.leaseData.title;
		params['rent'] 						= context.state.leaseData.contract_amount;
		params['rent_due_day'] 				= context.state.leaseData.rent_due_day;
		params['term_length'] 				= context.state.leaseData.term_length;
		params['rent_payment_option'] 		= context.state.selected_rent_payment_option;
		params['tenant_pay_rent_id'] 		= context.state.selected_tenant_pay_rent_id;
		params['unit_id'] 					= context.state.selectedUnitId;
		params['notify_tenant'] 			= context.state.notifyTenant;
		params['effective_date'] 			= context.state.leaseData.effective_date;
		params['prepaid_end_date']			= context.state.leaseData.prepaid_end_date;
		// #  Send to server object for processing
		var data = this.server.getData(url, params, true, "PUT");
		// #  Listen to our data
		data
		.done(function(response){
			if(response.data.error_user_authentication == 1)
			{
			}
			else if(response.data.error || (response.status == 1 || response.status == 2))
			{
				// #  Display error
				modal.showInfo("Oops! " + response.data.error, "danger", "top", "center");
			} else {
				if ((tenantArray !== 'undefined' || tenantArray.length != 0) && context.state.notifyTenant == true){
					modal.showSuccess("Lease Updated!","Tenant(s) have been notified of updated lease.");
				} else {
					modal.showSuccess("Lease Updated!","Lease was successfully updated.");
				}
			}
		})
		.fail(function(e){
			modal.showInfo("Oops! Looks like you are missing data.", "warning", "top", "center");
		});
	},
	saveLeaseOnboarding: function(context) {
		var self 		= this;
		const leaseData = context.state.leaseData;
		var url 		= "leases/" + self.leaseID;
		var params 		= context.state.lease;

		params['security_deposit'] 		= leaseData.deposit_amount;
		params['pet_deposit'] 			= leaseData.pet_deposit_amount;
		params['rent_increase_in_months']  = leaseData.increase_rent_length;
		params['rent_increase_amount']  = leaseData.increase_rent_amount;
		params['sales_max_amount'] 		= leaseData.sales_max;
		params['sales_min_amount'] 		= leaseData.sales_min;
		params['sales_percentage'] 		= leaseData.sales_percentage;
		params['prorate_rent'] 			= leaseData.prorate_amount;
		params['title'] 				= context.state.leaseData.title;
		params['rent'] 					= context.state.leaseData.contract_amount;
		params['rent_due_day'] 			= context.state.leaseData.rent_due_day;
		params['term_length'] 			= context.state.leaseData.term_length;
		params['unit_id'] 				= context.state.selectedUnitId;
		params['prepaid_end_date']			= context.state.leaseData.prepaid_end_date;
		var data = this.server.getData(url, params, true, "PUT");
		data
		.done(function(response){
			if(response.data.error_user_authentication == 1)
			{
			}
			else if(response.data.error || (response.status == 1 || response.status == 2))
			{
			} else {
				var contract_id = 0;
				var type = "";

				if(self.leaseID == 0) {
					contract_id = response.data.contract_id;
					type = "new_lease";
				}

				context.triggerUpload(contract_id, type);
			}
		})
		.fail(function(e){
			modal.showInfo("Oops! Looks like you are missing data.", "warning", "top", "center");
		});
	},
	moveIn: function(leaseId, tenantData, callback) {
		var self = this;
		var url = "leases/movein/" + leaseId;
		var params = {
			tenant_ids: tenantData.tenantsIdList,
			contract_amount: tenantData.rentAmount,
			security_deposit: tenantData.securityDeposit,
			pet_deposit: tenantData.petDeposit,
			effective_date: tenantData.effectiveDate,
			contract_expiration_date: tenantData.expirationDate,
			rent_due_day: tenantData.rentDueDay,
			term_length: tenantData.termLength,
			request_electronic: tenantData.requestElectronic,
			rent_payment_option: tenantData.rentPaymentOption,
			tenant_pay_rent_id: tenantData.tenantPayRentId,
			collect_security_deposit: tenantData.collectSecurityDeposit,
			collect_pet_deposit: tenantData.collectPetDeposit,
			collect_rent: tenantData.collectRentNow,
			due_at: tenantData.collectRentDate,
		};

		var data = this.server.getData(url, params, true, "PUT");
		data
		.done(function(response){
			if(response.data.error_user_authentication == 1)
			{
			}
			else if(response.data.error || (response.status == 1 || response.status == 2))
			{
			} else {
				self.didMoveIn = true;
				if(callback) {
					callback(response);
				}
			}
		})
		.fail(function(e){
			modal.showInfo("Oops! Looks like you are missing data.", "warning", "top", "center");
		});
	},
	moveOut: function(leaseId, tenantId, tenantName, callback) {
		var self = this;
		var url = "leases/moveout/" + leaseId + "/tenant/" + tenantId;
		var data = self.server.getData(url, null, true, "PUT");
		data
		.done(function(response){
			if(callback) {
				callback(response);
			}
			modal.showInfo("Tenant " + tenantName + " successfully moved out!", "success", "top", "center");
		})
		.fail(function(e){
			modal.showInfo("Oops! Something went wrong!", "danger", "top", "center");
		});
	},
	getElectronicSignature: function(id, callback) {
		var url = "signature?token=" + id;
		var data = this.server.getData(url, null, true);
		data.done(function(response){
			// #  Validate response
			if(response.data.error_user_authentication == 1)
			{
			}
			else if(response.data.error || (response.status == 1 || response.status == 2))
			{
				// #  Display error
                modal.showInfo("Oops! " + response.data.error, "danger", "top", "center");
			}
			callback(response);
		})
		.fail(function(e){
			browserHistory.replace('/login');
		});
	},
	sendElectronicSignature: function(data, callback) {
		var url = "signature";
		var data = this.server.getData(url, data, true, "POST");
		data.done(function(response){
			// #  Validate response
			if(response.data.error_user_authentication == 1)
			{
			}
			else if(response.data.error || (response.status == 1 || response.status == 2))
			{
				// #  Display error
                modal.showInfo("Oops! " + response.data.error, "danger", "top", "center");
			}
			callback(response);
		})
		.fail(function(e){
			modal.showInfo("Something happened, please try again.", "danger", "top", "center");
			browserHistory.replace('/login');
		});
	},
	createRentInvoice: function(id, chargeAmount, dueDate, type, description, callback) {
		var url = "lease/rent/generate/invoice";
		var param = {
			charge: chargeAmount,
			contract_id: id,
			due_at: dueDate,
			type: type,
			description
		}
		var data = this.server.getData(url, param, true, "POST");
		data.done(function(response){
			// #  Validate response
			if(response.data.error_user_authentication == 1)
			{
			}
			else if(response.data.error || (response.status == 1 || response.status == 2))
			{
				// #  Display error
                modal.showInfo("Oops! " + response.data.error, "danger", "top", "center");
			}
			callback(response);
		})
		.fail(function(e){
			modal.showInfo("Something happened, please try again.", "danger", "top", "center");
		});
	},
	getTenantData: function(callback) {
		var url = "tenant/lease";
		var data = this.server.getData(url, data, false);
		data
		.done(function(response){
			if (callback) {
				callback(response);
			}
		})
		.fail(function(e){
			modal.showInfo("Oops! Something went wrong!", "danger", "top", "center");
		});
	},
	requestMoveOut: function(callback) {
		var url = "tenant/request/moveout"
		var data = this.server.getData(url, data, false, "POST");
		data
		.done(function(response) {
			if (callback) {
				callback(response);
			}
		})
		.fail(function(e) {
			modal.showInfo("Oops! Failed to request move out!", "danger", "top", "center");
		})
	},
	requestRenewal: function(callback) {
		var url = "tenant/request/renewal"
		var data = this.server.getData(url, data, false, "POST");
		data
		.done(function(response) {
			if (callback) {
				callback(response);
			}
		})
		.fail(function(e) {
			modal.showInfo("Oops! Failed to send lease renewal!", "danger", "top", "center");
		})
	},
	requestLeaseESig: function(leaseID) {
		var url = "leases/esig/" + leaseID;
		var data = this.server.getData(url, data, true);
		data
		.done(function(response) {
			modal.showInfo("An email to request e-signature has been sent to any tenants that have not signed!", "success", "top", "center");
		})
		.fail(function(e) {
			modal.showInfo("Oops! Failed to request E-signature!", "danger", "top", "center");
		})
	},
	requestLeaseRenewal: function(leaseID) {
		var url = "leases/renew/" + leaseID;
		var data = this.server.getData(url, data, true);
		data
		.done(function(response) {
			modal.showInfo("An email to alert for the lease renewal has been sent to all associated tenants!", "success", "top", "center");
		})
		.fail(function(e) {
			modal.showInfo("Oops! Failed to send lease renewal!", "danger", "top", "center");
		})
	},
	requestLeaseDeposit: function(leaseID) {
		var url = "leases/requestdeposit/" + leaseID;
		var data = this.server.getData(url, data, true);
		data
		.done(function(response) {
			modal.showInfo("An email to request security deposit has been sent to all associated tenants!", "success", "top", "center");
		})
		.fail(function(e) {
			modal.showInfo("Oops! Failed to request deposit!", "danger", "top", "center");
		})
	},
	getSalesReported: function(callback) {
		var url = "lease/sales/reporting";
		var data = this.server.getData(url, null, true);
		data
		.done(function(response){
			if(response.data.error_user_authentication == 1)
			{
			}
			else if(response.data.error || (response.status == 1 || response.status == 2))
			{
                modal.showInfo("Oops! " + response.data.error, "danger", "top", "center");
			}
			if (callback) {
				callback(response)
			}
		})
		.fail(function(e){
			modal.showInfo("Oops! Something went wrong!", "danger", "top", "center");
		});
	},
	getSalesReportedWithLease: function(leaseId, callback) {
		var url = "lease/sales/report/" + leaseId;
		var data = this.server.getData(url, null, true);
		data
		.done(function(response){
			if(response.data.error_user_authentication == 1)
			{
			}
			else if(response.data.error || (response.status == 1 || response.status == 2))
			{
                modal.showInfo("Oops! " + response.data.error, "danger", "top", "center");
			}
			if (callback) {
				callback(response)
			}
		})
		.fail(function(e){
			modal.showInfo("Oops! Something went wrong!", "danger", "top", "center");
		});
	},
	getTransactionHistory: function(callback) {
		var url = "lease/transaction/history";
		var data = server.getData(url, null, true, "GET");
		data
		.done(function(response){
			if (response.status === 'ERROR') {
				modal.showInfo('Error! ' + JSON.parse(response.message.httpBody).error.message, 'danger', 'top', 'center');
			} else if (response.status == 'ERROR_INTERNAL') {
				modal.showInfo('Error! ' + response.message[0], 'danger', 'top', 'center');
			} else {
                if (callback) {
                    callback(response);
                }
			}
		})
		.fail(function(e){
			modal.showInfo("Oops! Looks like you are missing data.", "warning", "top", "center");
		});
	},
	getTransactionHistoryWithLeaseId: function(callback, leaseID) {
		var url = "lease/transaction/history/" + leaseID;
		var data = server.getData(url, null, true, "GET");
		data
		.done(function(response){
			if (response.status === 'ERROR') {
				modal.showInfo('Error! ' + JSON.parse(response.message.httpBody).error.message, 'danger', 'top', 'center');
			} else if (response.status == 'ERROR_INTERNAL') {
				modal.showInfo('Error! ' + response.message[0], 'danger', 'top', 'center');
			} else {
                if (callback) {
                    callback(response);
                }
			}
		})
		.fail(function(e){
			modal.showInfo("Oops! Looks like you are missing data.", "warning", "top", "center");
		});
	},
	deleteTransaction: function(data, callback) {
		var url = "tenant/billing/delete/invoice/" + data.tenant_payment_history_id;
		var params = data;
		var data = server.getData(url, params, true, 'DELETE');
		data
		.done(function(response){
			if (response.status === 'ERROR') {
				modal.showInfo('Error! ' + JSON.parse(response.message.httpBody).error.message, 'danger', 'top', 'center');
			} else if (response.status == 'ERROR_INTERNAL') {
				modal.showInfo('Error! ' + response.message[0], 'danger', 'top', 'center');
			} else {
				callback(response);
			}
		})
		.fail(function(e){
            if (e.status == 404) {
				modal.showInfo(e.responseText, "danger", "top", "center");
            } else {
                modal.showInfo("Oops! Looks like you are missing data.", "warning", "top", "center");
            }
		});
	},
	markInvoicePaid: function(data, callback) {
		var url = "tenant/billing/invoice/paid/" + data.tenant_payment_history_id;
		var params = data;
		var data = server.getData(url, params, true, 'PUT');
		data
		.done(function(response){
			if (response.status === 'ERROR') {
				modal.showInfo('Error! ' + JSON.parse(response.message.httpBody).error.message, 'danger', 'top', 'center');
			} else if (response.status == 'ERROR_INTERNAL') {
				modal.showInfo('Error! ' + response.message[0], 'danger', 'top', 'center');
			} else {
				callback(response);
			}
		})
		.fail(function(e){
            if (e.status == 404) {
				modal.showInfo(e.responseText, "danger", "top", "center");
            } else {
                modal.showInfo("Oops! Looks like you are missing data.", "warning", "top", "center");
            }
		});
	},
	updatePaymentDate: function(data, dueDate, callback) {
		var url 			= "tenant/billing/invoice/paymentdate/" + data.tenant_payment_history_id;
		var params 			= data;
		params['new_date'] 	= dueDate;
		var data = server.getData(url, params, true, 'PUT');
		data
		.done(function(response){
			if (response.status === 'ERROR') {
				modal.showInfo('Error! ' + JSON.parse(response.message.httpBody).error.message, 'danger', 'top', 'center');
			} else if (response.status == 'ERROR_INTERNAL') {
				modal.showInfo('Error! ' + response.message[0], 'danger', 'top', 'center');
			} else {
				callback(response);
			}
		})
		.fail(function(e){
            if (e.status == 404) {
				modal.showInfo(e.responseText, "danger", "top", "center");
            } else {
                modal.showInfo("Oops! Looks like you are missing data.", "warning", "top", "center");
            }
		});
    },
	voidTransaction: function(data, callback) {
		var url = "billing/cancel/transaction/" + data.transaction_id;
		var data = server.getData(url, data, true, "DELETE");
		data
		.done(function(response){
			callback(response);
		})
		.fail(function(e){
            if (e.status == 404) {
				modal.showInfo(e.responseText, "danger", "top", "center");
            } else {
                modal.showInfo("Oops! Looks like you are missing data.", "warning", "top", "center");
            }
		});
	},
	reportSales: function(data, amount, callback) {
		var url 			 = "lease/sales/report/" + data.tenant_sales_report_id;
		var params 			 = data;
		params['new_amount'] = amount;
		var data = server.getData(url, params, true, 'PUT');
		data
		.done(function(response){
			callback(response);
		})
		.fail(function(e){
            if (e.status == 404) {
				modal.showInfo(e.responseText, "danger", "top", "center");
            } else {
                modal.showInfo("Oops! Looks like you are missing data.", "warning", "top", "center");
            }
		});
    },
	getLeaseLineItems: function(leaseId, callback) {
		var url = "lease/" + leaseId + "/invoices";
		var data = server.getData(url, null, true, 'GET');
		data
		.done(function(response){
			if (callback) {
				callback(response);
			}
		})
		.fail(function(e){
            if (e.status == 404) {
				modal.showInfo(e.responseText, "danger", "top", "center");
            } else {
                modal.showInfo("Oops! Looks like you are missing data.", "warning", "top", "center");
            }
		});
    },
	saveLeaseLineItems: function(leaseId, invoiceData, callback) {
		var params = {
			invoices: invoiceData
		}
		var url = "lease/" + leaseId + "/invoices";
		var data = server.getData(url, params, true, 'POST');
		data
		.done(function(response){
			if (callback) {
				callback(response);
			}
		})
		.fail(function(e){
            if (e.status == 404) {
				modal.showInfo(e.responseText, "danger", "top", "center");
            } else {
                modal.showInfo("Oops! Looks like you are missing data.", "warning", "top", "center");
            }
		});
    },
	deleteLeaseLineItem: function(leaseId, lineItemId, callback) {
		var url = "lease/" + leaseId + "/invoice/item/" + lineItemId;
		var data = server.getData(url, null, true, 'DELETE');
		data
		.done(function(response){
			if (callback) {
				callback(response);
			}
		})
		.fail(function(e){
            if (e.status == 404) {
				modal.showInfo(e.responseText, "danger", "top", "center");
            } else {
                modal.showInfo("Oops! Looks like you are missing data.", "warning", "top", "center");
            }
		});
    },
	/**
	*
	* set default state for when creating a new user
	*
	*/
	setDefaultState: function(context){
		context.setState({
			leaseData: {
				term_length: 1,
				rent_due_day: 1,
				increase_rent_length: 1,
			}
		});
	},

    setLeaseID: function(leaseID){
        this.leaseID = leaseID;
    }
});

export let lease = new Lease();


// WEBPACK FOOTER //
// app/core/controllers/Lease.js